import { faChevronDown } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useCallback, useRef, useState } from 'react'

const DEFAULT_HEIGHT = '0px'
const DEFAULT_ROTATION = 'transform duration-700 ease'

export const Accordion = ({ label, children }) => {
  const [isActive, setIsActive] = useState(false)
  const [height, setHeight] = useState(DEFAULT_HEIGHT)
  const [rotate, setRotate] = useState(DEFAULT_ROTATION)

  const contentRef = useRef(null)

  const toggleAccordion = useCallback(() => {
    // toggle open/close
    setIsActive((prevState) => !prevState)

    // expand height of content
    setHeight(
      isActive ? DEFAULT_HEIGHT : `${contentRef.current.scrollHeight + 16}px`
    )

    // set state to rotate chevron
    setRotate(
      isActive ? DEFAULT_ROTATION : 'transform duration-700 ease -rotate-180'
    )
  }, [isActive])

  return (
    <div className="flex flex-col">
      <button
        onClick={toggleAccordion}
        className="py-6 box-border appearance-none cursor-pointer focus:outline-none flex items-center justify-between hover:bg-neutral_1 pl-4 pr-4 pt-2 pb-2 rounded-sm border-2 border-neutral font-manrope bg-white text-neutral_4"
      >
        {label}
        <FontAwesomeIcon
          icon={faChevronDown}
          alt="Chevron icon"
          className={`${rotate} inline-block`}
        />
      </button>
      <div
        ref={contentRef}
        style={{ maxHeight: `${height}` }}
        className={`overflow-auto transition-max-height duration-500 ease-in-out bg-neutral_1 ${
          height === DEFAULT_HEIGHT ? '' : 'p-2'
        }`}
      >
        <div>{children}</div>
      </div>
    </div>
  )
}
